import '@fortawesome/fontawesome-svg-core/styles.css'
import './src/index.css'

import { config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core'
import type { GatsbyBrowser } from 'gatsby'
import { I18nextProvider } from 'react-i18next'

import i18n from './src/i18n/config'

fontAwesomeConfig.autoAddCss = false

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
